import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export const AuthSuccessPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const [error, setError] = useState('');
  // Cierre de seguridad: el token del callback de Google se canjea UNA sola vez,
  // aunque el efecto se vuelva a disparar por un cambio de dependencias.
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const token = searchParams.get('token');
    const oauthError = searchParams.get('error');

    if (oauthError) {
      setError('Error al iniciar sesion con Google');
      setTimeout(() => navigate('/login?error=oauth_failed'), 2000);
      return;
    }

    if (token) {
      loginWithToken(token)
        .then(() => navigate('/'))
        .catch(() => {
          setError('Error al procesar la autenticacion');
          setTimeout(() => navigate('/login'), 2000);
        });
    } else {
      navigate('/login');
    }
  }, [searchParams, navigate, loginWithToken]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--color-bg)]">
      <div className="text-center p-8">
        {error ? (
          <>
            <p className="text-red-500 text-lg font-medium mb-2">{error}</p>
            <p className="text-[var(--color-text-muted)] text-sm">Redirigiendo...</p>
          </>
        ) : (
          <>
            <div className="w-10 h-10 border-3 border-[var(--color-accent)] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
            <p className="text-[var(--color-text)] font-medium">Completando inicio de sesion...</p>
            <p className="text-[var(--color-text-muted)] text-sm mt-1">Procesando autenticacion con Google</p>
          </>
        )}
      </div>
    </div>
  );
};
